<template>
  <div class="rankings" v-bind:style="{ paddingBottom: $store.state.paddingBottom + 'px' }">

    <keep-alive>
      <NavigationBar id="rankingsNavigationBarId" ref="rankingsNavigationBarRef">
        <template v-slot:center>
          <div class="navigation_title--headline">
            {{ $t('menu.total_ranking') }}
          </div>
          <div v-if="finishedMatches && matchCount && !matchRunning" class="navigation_title--subline">
            {{ $t('after_x_of_y_matches', { finished: finishedMatches, total: matchCount }) }}
          </div>
          <div v-else-if="matchRunning" class="navigation_title--subline">
            <span class="match_result_live">Live</span>
          </div>
        </template>
        <template v-slot:right>
          <div v-on:click="openHelp" class="navigation_icon small">
            <HintIcon v-if="!helpActive"></HintIcon>
            <HintIconInverted v-else ></HintIconInverted>
          </div>
          <div v-on:click="toggleSearch" class="navigation_icon small">
            <SearchIcon></SearchIcon>
          </div>
        </template>
      </NavigationBar>
    </keep-alive>
    
    <div v-if="helpActive" class="input-container" style="margin-top: 20px; margin-bottom: 20px; padding: 0px 0px;">
        <div class="input-infotext">

          <div class="input-infotext" v-if="betmode === 1 && sortmode === 1 && !isTournament() && !isBattle()" style="margin-left: 20px; margin-right: 20px;">{{ $t('rankings.tie_paragraph_1') }}</div>
          <div class="input-infotext" v-else-if="betmode === 1 && sortmode === 2 && !isTournament() && !isBattle()" style="margin-left: 20px; margin-right: 20px;">{{ $t('rankings.tie_paragraph_2') }}</div>
          <div class="input-infotext" v-else-if="betmode === 2 && !isTournament() && !isBattle()" style="margin-left: 20px; margin-right: 20px;">{{ $t('rankings.tie_paragraph_3') }}</div>
          <div class="input-infotext" v-else-if="isTournament() || isBattle()" style="margin-left: 20px; margin-right: 20px;">{{ $t('rankings.tie_paragraph_1_tournament') }}</div>
          <div class="input-infotext" style="margin-left: 20px; margin-right: 20px;">{{ $t('rankings.table_columns_description') }}</div>
          <div class="table-view">
            <tr class="help_item">
              <td class="column">{{ $t('rankings_table_header_points') }}</td>
              <td>{{ $t('rankings.help_total_points') }}</td>
            </tr>
            <tr class="help_item">
              <td class="column"><img src="../assets/icons/ic_16_points.svg" v-bind:alt="$t('rankings.help_bet_points')" v-bind:title="$t('rankings.help_bet_points')"></td>
              <td>{{ $t('rankings.help_bet_points') }}</td>
            </tr>
            <tr class="help_item">
              <td class="column"><img src="../assets/icons/ic_16_questions.svg" v-bind:alt="$t('rankings.help_questions_points')" v-bind:title="$t('rankings.help_questions_points')"></td>
              <td>{{ $t('rankings.help_questions_points') }}</td>
            </tr>
            <tr class="help_item">
              <td class="column">{{ $t('rankings.help_points_correction_short') }}</td>
              <td>{{ $t('rankings.help_points_correction') }}</td>
            </tr>
            <tr v-if="!isBattle() && !isTournament() && !isTeamsBetgame()" class="help_item">
              <td class="column"><img src="../assets/icons/ic_16_star.svg" v-bind:alt="$t('rankings.help_matchday_wins')" v-bind:title="$t('rankings.help_matchday_wins')"></td>
              <td>{{ $t('rankings.help_matchday_wins') }}</td>
            </tr>
            <tr v-if="betmode === 1" class="help_item">
              <td class="column">Exa</td>
              <td>{{ $t('rankings.help_exact_bets_count') }}</td>
            </tr>
            <tr v-if="betmode === 1" class="help_item">
              <td class="column">Dif</td>
              <td>{{ $t('rankings.help_bet_goal_diff_count') }}</td>
            </tr>
            <tr v-if="betmode === 1" class="help_item">
              <td class="column">Ten</td>
              <td>{{ $t('rankings.help_bet_tendency_count') }}</td>
            </tr>
            <tr class="help_item">
              <td class="column">{{ $t('rankings.zero_points') }}</td>
              <td>{{ $t('rankings.help_zero_points_count') }}</td>
            </tr>
            <tr class="help_item">
              <td class="column">{{ $t('rankings.count_short') }}</td>
              <td>{{ $t('rankings.help_bet_count') }}</td>
            </tr>
          </div>
        </div>
    </div>
    
    <RankingsTableScrolling v-if="hasSeasonStarted() || (this.$store.state.userCount && this.$store.state.userCount > 1000)" :searchActive="searchActive"></RankingsTableScrolling>
    <BetgameUsersTable v-else-if="((!hasSeasonStarted()) && betgameUsers.length > 0) && (this.$store.state.userCount && this.$store.state.userCount <= 1000)" :betgameUsers="betgameUsers" :searchActive="searchActive"></BetgameUsersTable>

    <modal class="modal" name="rankings-help" id="rankings-help" :scrollable="true" width="100%" height="auto">
      <div class="modal-header">
        <div class="modal-header-left"></div>
        <div class="modal-header-center"></div>
        <div class="modal-header-right">
          <button
              type="button"
              class="btn-close"
              @click="$modal.hide('rankings-help')"
              aria-label="Close modal">
          </button>
        </div>
      </div>
      <div class="modal-body">
        <div class="table-view">
          <tr class="help_item">
            <td class="column">{{ $t('rankings_table_header_points') }}</td>
            <td>Gesamtpunkte aus Tippabgabe und Sonderfragen</td>
          </tr>
          <tr class="help_item">
            <td class="column"><img src="../assets/icons/ic_16_points.svg" alt="Puktzahl Tippen" title="Puktzahl Tippen"></td>
            <td>Punkte aus der Tippabgabe</td>
          </tr>
          <tr class="help_item">
            <td class="column"><img src="../assets/icons/ic_16_questions.svg" alt="Puktzahl Sonderfragen" title="Puktzahl Sonderfragen"></td>
            <td>Punkte durch Sonderfragen</td>
          </tr>
          <tr v-if="!isBattle()" class="help_item">
            <td class="column"><img src="../assets/icons/ic_16_star.svg" alt="Spieltagssiege" title="Spieltagssiege"></td>
            <td>Anzahl Spieltagssiege</td>
          </tr>
          <tr class="help_item">
            <td class="column">Exa</td>
            <td>Exaktes Spielergebnis getippt</td>
          </tr>
          <tr class="help_item">
            <td class="column">Dif</td>
            <td>Richtige Tordifferenz getippt</td>
          </tr>
          <tr class="help_item">
            <td class="column">Ten</td>
            <td>Richtige Tendenz getippt</td>
          </tr>
          <tr class="help_item">
            <td class="column">{{ $t('rankings.zero_points') }}</td>
            <td>Falsche Tipps</td>
          </tr>
          <tr class="help_item">
            <td class="column">{{ $t('rankings.count_short') }}</td>
            <td>Anzahl abgegebener Tipps</td>
          </tr>
        </div>
      </div>
    </modal>
    
  </div>
</template>

<script>
  //import { mapState } from 'vuex'
  import RankingsTableScrolling from '../components/RankingsTableScrolling'
  import NavigationBar from './../components/NavigationBar'
  import BetgameUsersTable from '@/components/BetgameUsersTable'
  import HintIcon from './../components/icons/HintIcon'
  import SearchIcon from './../components/icons/SearchIcon'
  import HintIconInverted from '@/components/icons/HintIconInverted'
  export default {
    name: 'rankings',
    components: { HintIconInverted, RankingsTableScrolling, NavigationBar, BetgameUsersTable, HintIcon, SearchIcon },
    data () {
      return {
        helpActive: false,
        searchActive: false,
      }
    },
    created() {
      if(!this.$store.state.pointsCorrectionsCount || this.$store.state.pointsCorrectionsCount === 0 && this.$store.state.betgameId) {
        this.$store.dispatch('fetchPointsCorrectionsCount', 0)
      }
      if(!this.$store.state.userCount || this.$store.state.userCount < 1) {
        this.$store.dispatch('fetchUserCount', 'planned').then(response => {
          
        })
      }
      window.localStorage.setItem('hideSpecialQuestionMissingSolutionHint', 0)
    },
    computed: {
      sortmode() {
        return this.$store.state.betgame.sort_mode || 1
      },
      betmode() {
        return this.$store.state.betgame.bet_mode || 1
      },
      betgameUsers () {
        if(this.$store.state.betgame && (!this.$store.state.betgameUsers || this.$store.state.betgameUsers.length === 0) && 
          (this.$store.state.userCount && this.$store.state.userCount <= 1000)) {
          this.$store.dispatch('fetchBetgameUsers', this.$store.state.betgame.id)
        }
        return this.$store.state.betgameUsers ? this.$store.state.betgameUsers : []
      },
      matchRunning() {
        return this.$store.getters.matchWithLiveGoals
      },
      matchCount() {
        if(this.$store.state.betgame && this.$store.state.betgame.competition && this.$store.state.betgame.competition.id === 10700) {
          return 51
        } else if(this.$store.state.betgame && this.$store.state.betgame.competition && this.$store.state.betgame.competition.id === 36) {
          return 51
        } else if(this.$store.state.betgame && this.$store.state.betgame.competition && this.$store.state.betgame.competition.id === 1180) {
          return 31
        } else if(this.$store.state.betgame && this.$store.state.betgame.competition && this.$store.state.betgame.competition.id === 139 && 
          this.$store.state.betgame.season && this.$store.state.betgame.season.id === 16) {
          return 104
        }
        return this.$store.state.matches.length
      },
      finishedMatches() {
        return this.$store.getters.finishedMatches
      }
    },
    methods: {
      toggleSearch() {
        this.searchActive = !this.searchActive
      },
      openMenu () {
        this.$modal.show('betgame-menu')
      },
      openHelp() {
        this.helpActive = !this.helpActive
        //this.$modal.show('rankings-help');
      },
    }
  }
</script>

<style lang="scss" scoped>
  ul {
    list-style: none;
  }
  .col_user {
    text-align: left;
    overflow: hidden;
    width: 50%;
  }
  .col_value {
    text-align: right;
    overflow: hidden;
  }
  .col_points {
    margin-right: 10px;
  }
  .match_result_live {
    color: var(--color-primary);
    font-weight: 500;
    text-transform: uppercase;
    position: relative;
    padding-right: 12px;
    font-size: 14px;
    opacity: .24;
    -webkit-transform: scale(0.2);
    transform: scale(0.2);
    -webkit-animation: live-data-v-43a5ba3a 3.4s infinite;
    animation: live-data-v-43a5ba3a 3.4s infinite;
  
    &:before {
      content: '';
      position: absolute;
      right: 0;
      top: 5px;
      width: 6px;
      height: 6px;
      border-radius: 3px;
      background: var(--color-primary);
    }
  }
  @media screen and (max-width: 567px) {
    .mobile-hidden {
      display: none;
    }
  }
  .help_item {
    padding: 5px 10px;
    color: gray;
  }
  .column {
    padding: 0 10px;
  }
</style>
